// import DailyCarousel from "@/components/screens/home/DailyCarousel";
// import { RouteCard } from "@/components/dataDisplay/cards/RouteCard";
import { RouteCard } from '@/components/dataDisplay/cards/RouteCard';
import Skeleton from '@/components/dataDisplay/Skeleton';
import ContinueProgressing from '@/components/home/ContinueProgressing';
import DailyCarousel from '@/components/home/DailyCarousel';
import { routes } from '@/constants/routes';
import theme from '@/constants/theme';
import useLearningRoutes from '@/context/routes/hook';
import { Route } from '@/services/routes/route.vm';
import { generatePath, Link } from 'react-router';

function sortByLastInteraction(paths: Route[], limit: number | null = null, order: 'desc' | 'asc' = 'desc') {
  const sortedPaths = paths.sort((a, b) => {
    const dateA = a.lastInteraction ? Date.parse(a.lastInteraction) : 0;
    const dateB = b.lastInteraction ? Date.parse(b.lastInteraction) : 0;

    return order === 'desc' ? dateB - dateA : dateA - dateB;
  });

  return limit ? sortedPaths.slice(0, limit) : sortedPaths;
}

export default function HomeScreen() {
  const { routesList, loadingRoutes } = useLearningRoutes();
  const sortedRoutes = sortByLastInteraction(routesList, 3);
  const routesWithUserProgress = sortedRoutes.filter(
    (route) => route.progressStatus === 'IN_PROGRESS' || route.progressStatus === 'COMPLETED',
  );

  return (
    <div style={styles.container}>
      <div style={styles.scrollContainer}>
        <ContinueProgressing routes={routesWithUserProgress} loading={loadingRoutes} />
        <div style={styles.content}>
          {/* Diario */}
          <div style={styles.section}>
            <div style={styles.titleContainer}>
              <h2 style={styles.titleText}>Diario</h2>
              <Link style={styles.link} to="/calendar">
                Ver todas las entradas
              </Link>
            </div>
            <DailyCarousel />
          </div>

          {/* Rutas */}
          <div style={styles.section}>
            <div style={styles.titleContainer}>
              <h2 style={styles.titleText}>Tus Rutas</h2>
              <Link style={styles.link} to={routes.routes.root}>
                Ver más rutas
              </Link>
            </div>
            {loadingRoutes && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <Skeleton width="100%" height="120px" borderRadius="8px" />
                <Skeleton width="100%" height="120px" borderRadius="8px" />
                <Skeleton width="100%" height="120px" borderRadius="8px" />
              </div>
            )}
            {!loadingRoutes && routesWithUserProgress.length === 0 ? (
              <p style={{ color: theme.colors.text.body }}>Aún no has iniciado ninguna ruta</p>
            ) : (
              <div style={styles.routeCardsContainer}>
                {routesWithUserProgress.map((route, index) => (
                  <Link
                    to={generatePath(routes.routes.detail, {
                      routeId: route.id,
                    })}
                    key={route.id}
                  >
                    <RouteCard
                      key={route.id}
                      routeNumber={route.order}
                      progress={route.progress}
                      title={route.title}
                      backgroundImage={route.coverImage}
                    />
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    flex: 1,
    backgroundColor: theme.colors.background.primary,
  },
  scrollContainer: {
    flex: 1,
    backgroundColor: theme.colors.background.primary,
  },
  scrollContent: {
    backgroundColor: theme.colors.background.primary,
  },
  content: {
    paddingLeft: 16,
    paddingRight: 16,
    backgroundColor: theme.colors.background.primary,
    marginTop: 24,
  },
  section: {
    marginBottom: 24,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  titleText: {
    color: '#fff',
  },
  routeCardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginTop: 12,
  },
  link: {
    color: theme.colors.primary,
    textDecoration: 'none',
  },
};
